var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgEyeClosed(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.635 21.221a1 1 0 01.022.022l5.05 5.05a1 1 0 01-1.414 1.414l-4.467-4.467A11.089 11.089 0 0116 25c-3.38 0-6.339-1.632-8.855-4.316a20.492 20.492 0 01-2.25-2.891 15.188 15.188 0 01-.79-1.346 1 1 0 01.014-.92 19.45 19.45 0 014.45-5.544L4.292 5.707a1 1 0 111.414-1.414l5.048 5.048a1 1 0 01.022.022l3.806 3.806.007.007 4.234 4.234.007.007 3.804 3.804zm1.44-2.675a17.5 17.5 0 001.783-2.548 18.513 18.513 0 00-2.463-3.314C21.224 10.368 18.745 9 15.998 9a8.12 8.12 0 00-1.87.214 1 1 0 01-.456-1.948A10.115 10.115 0 0116 7c3.38 0 6.339 1.632 8.855 4.316a20.492 20.492 0 012.25 2.891c.385.596.649 1.065.79 1.346a1 1 0 01-.013.918 19.5 19.5 0 01-2.277 3.363 1 1 0 01-1.53-1.288zM9.987 11.401a17.45 17.45 0 00-3.844 4.602 18.513 18.513 0 002.462 3.313C10.776 21.632 13.255 23 15.984 23a9.07 9.07 0 004.387-1.214l-2.321-2.322a4 4 0 01-5.514-5.514l-2.549-2.549zm4.04 4.041a1.999 1.999 0 002.53 2.53l-2.53-2.53z"
  }));
}

export default SvgEyeClosed;